import api from '../legacy/Helper/api';

export interface KnowledgeSourceInput {
  name: string;
  kind: 'api' | 'upload';
  url: string;
  content: string;
  format: 'auto' | 'json' | 'yaml' | 'html' | 'text' | 'markdown';
  auth_type: 'none' | 'bearer' | 'api_key';
  credential: string;
  header_name: string;
  records_path: string;
  fields: string[];
  next_url_path: string;
  max_pages: number;
}

export interface KnowledgeDocumentUpdate {
  content: string;
  format: KnowledgeSourceInput['format'];
}

export interface KnowledgeSource extends Omit<KnowledgeSourceInput, 'credential' | 'content'> {
  id: string;
  status: 'pending' | 'syncing' | 'ready' | 'error' | 'review_required';
  chunk_count: number;
  last_synced_at: string | null;
  last_error: string | null;
  has_credential: boolean;
  schema_changed: boolean;
}

export interface KnowledgePreview {
  preview_hash: string;
  chunk_count: number;
  chunks: string[];
  message: string;
}

export async function listKnowledgeSources() {
  return (await api().get<{ sources: KnowledgeSource[] }>('knowledge-sources')).data.sources;
}

export async function previewKnowledgeSource(input: KnowledgeSourceInput) {
  return (await api().post<KnowledgePreview>('knowledge-sources/preview', input)).data;
}

export async function createKnowledgeSource(input: KnowledgeSourceInput, previewHash: string) {
  const config: Partial<KnowledgeSourceInput> = { ...input };
  delete config.credential;
  return (await api().post<KnowledgeSource>('knowledge-sources', { ...config, preview_hash: previewHash })).data;
}

export async function previewExistingSource(id: string, document?: KnowledgeDocumentUpdate, credential?: string) {
  return (await api().post<KnowledgePreview>(`knowledge-sources/${id}/preview`, { document, credential })).data;
}

export async function syncKnowledgeSource(id: string, previewHash: string, document?: KnowledgeDocumentUpdate) {
  return (
    await api().post<KnowledgeSource>(`knowledge-sources/${id}/sync`, {
      preview_hash: previewHash,
      document,
    })
  ).data;
}

export async function deleteKnowledgeSource(id: string) {
  return (await api().delete<KnowledgeSource>(`knowledge-sources/${id}`)).data;
}
